export default {"src":"/_next/static/media/generic-thumbnail-xls.fb4b848a.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};